import {BaseContainerModel} from "../../../base-container.model";
import {bl_alg_cc_conversation_agent_squad_link_RowClass} from "../../../../dbschema";

export class ConversationAgentSquadLinkContainerModel extends BaseContainerModel {
  bl_alg_cc_conversation_agent_squad_link: bl_alg_cc_conversation_agent_squad_link_RowClass = new bl_alg_cc_conversation_agent_squad_link_RowClass();
}
